// const getConfig = ({env, isLocal}) => {
//     if (env === 'development' || isLocal) {
//         return {
//             isLocal,
//             url: {
//                 BASE_URL: 'http://localhost:3000',
//                 API_URL: isLocal ? 'http://localhost:44367' : 'http://localhost:44367/api',
//                 CDN_URL: 'https://cdn.mhs.com/mhscdndev/Gifted'
//             }
//         };
//     }

//     return {
//         isLocal,
//         url: {
//             BASE_URL: 'https://a2.mhs.com/ngat',
//             API_URL: 'https://a2.mhs.com/rap_api/api',
//             CDN_URL: 'https://cdn.mhs.com/mhscdn/Gifted'
//         }
//     }
// };

// export const config = getConfig({
//     env: process.env.NODE_ENV,
//     isLocal: false // Dev Switch
// });

export const config = window.globalConfig;

export const productId = 3;

export const termsReponse = {
    accept: 1,
    declined: 2
};

export const consentResponse = {
    accept: 1,
    declined: 2
};

export const assessmentStatus = {
    Complete: 'Complete' ,
    InProgress: 'InProgress',
    Fail: 'Fail'
};

export const specialMessages = {
    SaveSuccess: "Assessment saved successfully"
}

export const localDataExpiry = 3600000;
